"use client";

import React from 'react';
import './IndustryInsightsGrid.css';
import Link from 'next/link';

interface Insight {
    title: string;
    link: string;
}

interface IndustryInsightsGridProps {
    insights: Insight[];
}

const IndustryInsightsGrid: React.FC<IndustryInsightsGridProps> = ({ insights }) => {
    return (
        <div className="industry-insights-grid">
            {insights.map((insight, index) => (
                <div key={index} className="insight-card">
                    <h3>{insight.title}</h3>
                    <Link href={insight.link} className="read-more-btn" target="_blank" rel="noopener noreferrer">
                        Read More
                    </Link>
                </div>
            ))}
        </div>
    );
};

export default IndustryInsightsGrid;
